import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1b2142fa"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "Permissions"
};
var _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"Permissions__title\" data-v-1b2142fa> Permissions </div><div class=\"Permissions__description\" data-v-1b2142fa><p data-v-1b2142fa><b data-v-1b2142fa>Great news! You&#39;re only one step away from accessing the full potential of your AIVitars!</b></p><p data-v-1b2142fa>Before you dive in, we need to request some device permissions.</p><p data-v-1b2142fa>But don&#39;t worry, we believe in transparency and want you to know exactly <b data-v-1b2142fa>what we&#39;re asking for <i data-v-1b2142fa>and why</i></b>.</p><p class=\"textBold\" style=\"margin-top:50px;\" data-v-1b2142fa>To help you make an informed decision, we&#39;ve outlined the following information:</p><ul data-v-1b2142fa><li class=\"textBold\" data-v-1b2142fa><p class=\"textBold\" data-v-1b2142fa>The specific permissions we&#39;re requesting</p></li><li class=\"textBold\" data-v-1b2142fa><p class=\"textBold\" data-v-1b2142fa>The reason behind why we&#39;re requesting these permissions and the services that use them.</p></li><li class=\"textBold\" data-v-1b2142fa><p class=\"textBold\" data-v-1b2142fa>How we use and store your data</p></li></ul></div>", 2);
var _hoisted_4 = {
  "class": "Permissions__container"
};
var _hoisted_5 = {
  "class": "Permissions__icon-holder"
};
var _hoisted_6 = {
  "class": "Permissions__content"
};
var _hoisted_7 = {
  "class": "Permissions__content-title"
};
var _hoisted_8 = {
  "class": "Permissions__icon-text-internal"
};
var _hoisted_9 = {
  "class": "Permissions__button-container"
};
var _hoisted_10 = ["innerHTML"];
var _hoisted_11 = {
  "class": "Permissions__content-description"
};
var _hoisted_12 = ["onClick"];
var _hoisted_13 = ["innerHTML"];
var _hoisted_14 = ["onClick"];
var _hoisted_15 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  var _component_ButtonBasic = _resolveComponent("ButtonBasic");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_font_awesome_icon, {
    icon: "fa-times",
    "class": "Permissions__close",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.$store.commit('updateShowPermissionsScreen', false);
    })
  }), _hoisted_2, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.permissionsList, function (permission) {
    return _openBlock(), _createElementBlock("div", {
      key: permission.title
    }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_font_awesome_icon, {
      "class": _normalizeClass({
        'Permissions__icon': true,
        'Permissions__icon--shadow': true,
        'Permissions__icon--enabled': permission.permission_state == true && permission.permission_state != 'denied'
      }),
      icon: permission.icon
    }, null, 8, ["class", "icon"]), _createVNode(_component_font_awesome_icon, {
      "class": _normalizeClass({
        'Permissions__icon': true,
        'Permissions__icon--enabled': permission.permission_state == true && permission.permission_state != 'denied'
      }),
      icon: permission.icon
    }, null, 8, ["class", "icon"]), _createElementVNode("div", {
      "class": _normalizeClass({
        'Permissions__icon-text': true,
        'Permissions__icon-text--enabled': permission.permission_state
      })
    }, _toDisplayString(permission.permission_state === true && permission.permission_state != 'denied' ? 'Enabled' : '') + " " + _toDisplayString(permission.permission_state !== true && permission.permission_state != 'denied' && permission.permision_state !== false ? 'Blocked' : '') + " " + _toDisplayString(permission.permision_state === false ? 'Disabled' : ''), 3)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_font_awesome_icon, {
      "class": _normalizeClass({
        'Permissions__icon-internal': true,
        'Permissions__icon-internal--enabled': permission.permission_state
      }),
      icon: permission.icon
    }, null, 8, ["class", "icon"]), _createTextVNode(_toDisplayString(permission.title), 1)]), _createElementVNode("div", _hoisted_8, _toDisplayString(permission.permission_state ? 'Enabled' : 'Disabled'), 1), _createElementVNode("div", _hoisted_9, [!permission.permission_state && permission.permission_state !== true && permission.permission_state != 'denied' ? (_openBlock(), _createBlock(_component_ButtonBasic, {
      key: 0,
      "class": "Permissions__button",
      label: permission.buttonLabel,
      onClick: function onClick($event) {
        return permission.clickEvent();
      }
    }, null, 8, ["label", "onClick"])) : _createCommentVNode("", true)]), permission.permission_state !== true && permission.permission_state === 'denied' ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      "class": "notice",
      innerHTML: permission.blockedNotice
    }, null, 8, _hoisted_10)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_11, [_createElementVNode("p", {
      "class": "textBold expandedTitle",
      onClick: permission.expandClick
    }, [!permission.expandEnabled ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
      key: 0,
      icon: "fa-chevron-up"
    })) : _createCommentVNode("", true), permission.expandEnabled ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
      key: 1,
      icon: "fa-chevron-down"
    })) : _createCommentVNode("", true), _createTextVNode(" What This Enables ")], 8, _hoisted_12), permission.expandEnabled ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      "class": "expanded",
      innerHTML: permission.expandEnabledContent
    }, null, 8, _hoisted_13)) : _createCommentVNode("", true), _createElementVNode("p", {
      "class": "textBold expandedTitle",
      onClick: permission.expandStoreData
    }, [!permission.expandedStoreDataVideo ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
      key: 0,
      icon: "fa-chevron-up"
    })) : _createCommentVNode("", true), permission.expandedStoreDataVideo ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
      key: 1,
      icon: "fa-chevron-down"
    })) : _createCommentVNode("", true), _createTextVNode(" How we use and store your data ")], 8, _hoisted_14), permission.expandedStoreDataVideo ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      "class": "expanded",
      innerHTML: permission.expandStoreDataContent
    }, null, 8, _hoisted_15)) : _createCommentVNode("", true)])])])]);
  }), 128))]);
}